jQuery(document).ready(function($) {
    // if (is_dev) {
    //     write_message([387,2],'course',null,'appointment:125,course:1,appointments_list:appointment.generateMessageAppointmentsList,addresses:appointment.generateAddresses');
    // }
    // open_refresher_invitations_screen();
    // setTimeout(function() {
    //     $('th > label > input[type="checkbox"]:first').trigger('change');
    // }, 3000);
});
function checkWholeTable(elm) {
    const $ = jQuery.noConflict();
    const input = $(elm);
    const table = input.parents('table');
    const col_index = input.parents('th').index();
    const input_selector = table.find('td:nth-child('+(col_index+1)+')').find('input[type=checkbox]:not([disabled])');
    const value = input.is(':checked');
    if(value === true) {
        input_selector.prop('checked',true);
    } else {
        input_selector.removeAttr('checked');
    }

    if (table.is('[data-reloadable-url]') && !table.is('[data-simple-collection]') && input_selector.is('[data-no-reload]') === false && !table.is('[data-special-checkbox]')) {
        table.find('input[data-hidden-checked]').remove();
        if (value === true) {
            // Get all ids of data that's not yet on screen
            table.isLoading();

            let url = table[0].last_url;
            url = url + (url.split('?').length === 1 ? '?' : '&') + 'checkAll=1';

            if (table[0]['checkAjax']) {
                table[0]['checkAjax'].abort();
            }
            const type = table.attr('data-request-type') === undefined ? 'GET' : table.attr('data-request-type');
            const data = type === 'GET' ? {} : table[0]['last_data'];

            table[0]['checkAjax'] = $.ajax({
                url: url,
                type: type,
                data: data,
            }).done(function(data) {
                let selection = data.filter((v, i, a) => a.indexOf(v) === i);

                table[0]['checked_items'] = selection;

                table.find('tbody').find('input[type=checkbox]').unbind('change.removeFromSelection').bind('change.removeFromSelection', function() {
                    const thisValue = $(this).attr('value');
                    if (!$(this).is(':checked')) {
                        selection = selection.filter(function(value) {
                            return value != thisValue;
                        },thisValue);
                        table.find('thead').find('input[value="' + thisValue + '"][data-hidden-checked]').remove();
                    } else {
                        selection.push(thisValue);
                        selection = selection.filter((v, i, a) => a.indexOf(v) === i);
                    }
                });


                let filters_key = table.attr('data-filters-key');
                if (filters_key === undefined) {
                    filters_key = get_unique_id('data-filters-key');
                    table.attr('data-filters-key', filters_key);
                }

                const firstCheckbox = table.find('tbody').find('input[type=checkbox]:first');
                selection.forEach(function(id) {
                    const hidden_input = firstCheckbox.clone();

                    hidden_input.attr('type', 'hidden');
                    hidden_input.attr('data-' + filters_key + '-filter', 1);
                    hidden_input.attr('value', id);
                    hidden_input.attr('data-hidden-checked', 1);
                    table.find('thead').append(hidden_input);
                });
            }).fail(function(e,b,c) {
                if (b === 'abort') {
                    return;
                }
                console.log({e,b,c});
                squde_flash('Er is een fout opgetreden', 'alert');
            }).always(function() {
                table.doneLoading();
            })

        }

    } else {
        input_selector.trigger('change');
    }
}

function checkAllInThisContainer(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);

    const checked = elm.is(':checked');

    let id = elm.attr('id');
    if (id === undefined) {
        id = get_unique_id();
        elm.attr('id', id);
    }
    elm.parent().find('input[type="checkbox"]:not(:disabled):not([readonly]):not(#' + id + ')').each(function() {
        $(this)[0].checked = checked;
    })
}
